export const columns: any = [
  {
    title: 'select-all-btn',
    colSize: '3',
    sortable: false,
    active: false,
    col: 'select-btn'
  },
  {
    title: 'Attribute',
    colSize: '7',
    sortable: false,
    sort: 'desc',
    active: false,
    col: 'name',
  },
  {
    title: 'Description',
    colSize: '25',
    sortable: false,
    active: false,
    col: 'description'
  },
];
